<div class="wf-table-card">
  <table class="wf-table">
    <thead>
      <tr>
        <th class="col-date">Data/Hora</th>
        <th class="col-type">Tipo</th>
        <th>Descricao</th>
        <th class="col-user">Usuario</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of historico">
        <td class="col-date">{{ item.dataHora | date: 'dd/MM HH:mm' }}</td>
        <td class="col-type">{{ item.tipo }}</td>
        <td>{{ item.descricao }}</td>
        <td class="col-user">{{ item.usuario }}</td>
      </tr>
    </tbody>
  </table>
</div>
